import { api } from '../lib/api'

export interface AlpacaAccount {
  equity: number
  cash: number
  buyingPower: number
  portfolioValue: number
  unrealizedPnl: number
  unrealizedPnlPct: number
  currency: string
  status: string
  paper: boolean
}

export interface AlpacaPosition {
  symbol: string
  qty: number
  side: string
  avgEntryPrice: number
  currentPrice: number
  marketValue: number
  unrealizedPnl: number
  unrealizedPnlPct: number
}

export interface AlpacaOrder {
  id: string
  symbol: string
  side: string
  qty: number
  filledQty: number
  type: string
  status: string
  limitPrice: number | null
  filledAvgPrice: number | null
  createdAt: string
  filledAt: string | null
}

export interface PlaceOrderPayload {
  symbol: string
  qty: number
  side: 'buy' | 'sell'
  type: 'market' | 'limit'
  time_in_force?: string
  limit_price?: number
  paper: boolean
}

function getCredHeaders(): Record<string, string> {
  const key    = localStorage.getItem('bb_alpaca_key')    ?? ''
  const secret = localStorage.getItem('bb_alpaca_secret') ?? ''
  return {
    'apca-api-key-id':     key,
    'apca-api-secret-key': secret,
  }
}

export const alpacaApi = {
  getAccount: (paper = true): Promise<AlpacaAccount> =>
    api.get('/alpaca/account', {
      params:  { paper },
      headers: getCredHeaders(),
    }).then(r => r.data),

  getPositions: (paper = true): Promise<AlpacaPosition[]> =>
    api.get('/alpaca/positions', {
      params:  { paper },
      headers: getCredHeaders(),
    }).then(r => r.data),

  getOrders: (paper = true, status = 'all'): Promise<AlpacaOrder[]> =>
    api.get('/alpaca/orders', {
      params:  { paper, status, limit: 50 },
      headers: getCredHeaders(),
    }).then(r => r.data),

  placeOrder: (payload: PlaceOrderPayload): Promise<AlpacaOrder> =>
    api.post('/alpaca/orders', payload, {
      headers: getCredHeaders(),
    }).then(r => r.data),

  cancelOrder: (orderId: string, paper = true): Promise<{ cancelled: boolean }> =>
    api.delete(`/alpaca/orders/${orderId}`, {
      params:  { paper },
      headers: getCredHeaders(),
    }).then(r => r.data),

  hasCredentials: (): boolean => {
    return !!(localStorage.getItem('bb_alpaca_key') && localStorage.getItem('bb_alpaca_secret'))
  },

  saveCredentials: (key: string, secret: string) => {
    localStorage.setItem('bb_alpaca_key',    key)
    localStorage.setItem('bb_alpaca_secret', secret)
  },

  clearCredentials: () => {
    localStorage.removeItem('bb_alpaca_key')
    localStorage.removeItem('bb_alpaca_secret')
  },
}
